export default __webpack_public_path__ + "static/media/chevron_left-black-24dp.122c48ca.svg";